export function initCF7Forms() {
    const forms = document.querySelectorAll('.wpcf7');

    forms.forEach(form => {
        const submitBtn = form.querySelector('[type="submit"]');
        if (!submitBtn) return;

        const originalValue = submitBtn.value;

        form.addEventListener('wpcf7mailsent', function () {
            submitBtn.disabled = true;
            submitBtn.value = 'Надіслано!';
            submitBtn.classList.add('sent-success');

            setTimeout(() => {
                submitBtn.disabled = false;
                submitBtn.value = originalValue;
                submitBtn.classList.remove('sent-success');
            }, 3000);
        });
    });

    const updateInvalidState = () => {
        document.querySelectorAll('.wpcf7-form-control-wrap').forEach(wrap => {
            const input = wrap.querySelector('.wpcf7-form-control');
            if (input && input.classList.contains('wpcf7-not-valid')) {
                wrap.classList.add('has-error');
            } else {
                wrap.classList.remove('has-error');
            }
        });
    };

    const checkValidationState = (input) => {
        const wrap = input.closest('.wpcf7-form-control-wrap');
        if (!wrap) return;
        if (input.classList.contains('wpcf7-not-valid')) {
            wrap.classList.add('has-error');
        } else {
            wrap.classList.remove('has-error');
        }
    };

    // Події CF7
    document.addEventListener('wpcf7invalid', () => setTimeout(updateInvalidState, 20));
    document.addEventListener('wpcf7submit', () => setTimeout(updateInvalidState, 20));
    document.addEventListener('wpcf7mailsent', () => setTimeout(updateInvalidState, 20));

    // Реакція на введення
    document.addEventListener('input', e => {
        if (e.target.classList.contains('wpcf7-form-control')) {
            checkValidationState(e.target);
        }
    });

    document.addEventListener('blur', e => {
        if (e.target.classList.contains('wpcf7-form-control')) {
            setTimeout(() => checkValidationState(e.target), 10);
        }
    }, true);

    // Після загальної валідації
    document.addEventListener('wpcf7invalid', () =>
        setTimeout(() => {
            document.querySelectorAll('.wpcf7-form-control').forEach(checkValidationState);
        }, 20)
    );
}
